import { POST } from "@/src/network/fetchers";
import { IBaseApiResponse } from "@/src/network/network.types";
import * as yup from 'yup';

export interface IPlayerDeletionRequest {
    player: string;
    team: string;
    client: string;
}

export const deletePlayerSchema = yup.object({
    player: yup.string().min(1).required(),
    team: yup.string().min(1).required(),
    client: yup.string().min(1).required(),
});

/*
ROUTE
 */
export const PLAYER_DELETION_REQUEST = '/deletion-request';

/**
 * 
 * Handles the deletion request for a single player
 * 
 * @param request
 * @param accessToken 
 * @returns 
 */

export const deletionRequest = async (request: IPlayerDeletionRequest): Promise<IBaseApiResponse<unknown>> => {

    try {
        const res = await POST(PLAYER_DELETION_REQUEST, false, undefined, request);

        return {
            payload: res?.payload,
            success: res?.success,
            errors: res?.errors,
        }
    } catch (err) {
        return {
            payload: undefined, 
            success: false,
            errors: undefined,
        }
    }
   
}
